import React from 'react';
import PropTypes from 'prop-types';

import './ProductAnswerCardInaccurateFlag.scss';

const ProductAnswerCardInaccurateFlag = ({ handleInaccurateClick, inaccurate }) => (
	<div className="ProductAnswerCardInaccurateFlag">
		{inaccurate ? (
			<span className="ProductAnswerCardInaccurateFlag__flagged">Flagged</span>
		) : (
			<button className="ProductAnswerCardInaccurateFlag__button" type="button" onClick={handleInaccurateClick}>
				Inaccurate
			</button>
		)}
	</div>
);

ProductAnswerCardInaccurateFlag.propTypes = {
	handleInaccurateClick: PropTypes.func,
	inaccurate: PropTypes.bool
};

export default ProductAnswerCardInaccurateFlag;
